import React from "react";
import styled from "styled-components";

import { Strings } from "--root/strings/en";

import { ChooseDialogBody, ChooseDialogHeader, } from "./components/ChooseDialog";
import ChooseUserForm, { ChooseUserFormProps } from "./components/ChooseUserForm";

const StyledChooseUserDialog = styled.form`
    display: contents;
`;

export interface ChooseUserDialogProps extends ChooseUserFormProps {
    title?: string;
}

const ChooseUserDialog = (props: ChooseUserDialogProps) => {
    const {
        title = Strings.chooseUserDialog.defaultTitle,
        ...formProps
    } = props;

    return (
        <StyledChooseUserDialog>
            <ChooseDialogHeader title={title} onClose={props.onClose} />
            <ChooseDialogBody>
                <ChooseUserForm {...formProps} />
            </ChooseDialogBody>
        </StyledChooseUserDialog>
    );
};

export default ChooseUserDialog;
